import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Header, Modal } from 'semantic-ui-react';
import styled from 'styled-components';

import {
  isGLS,
  pickServiceGroupId,
  pickServiceGroupName,
  Subscription,
} from '@/types/subscriptions/subscription';

type Props = {
  subscription: Subscription;
  cancelSubscription: (id: number) => void;
};

export const CancelOrder: React.FC<Props> = ({
  subscription,
  cancelSubscription,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const { t } = useTranslation();

  const id = pickServiceGroupId(subscription);
  // https://github.com/globis-org/glopla-dev-portal/issues/457#issuecomment-437284552
  if (id && isGLS(id)) {
    return null;
  }

  return (
    <Styled>
      <Modal
        dimmer="blurring"
        trigger={
          <Button
            data-test="do-cancel"
            data-gtm="cancel-subscription"
            disabled={!subscription.isUpdatable}
            negative={true}
            type="submit"
            onClick={handleOpen}
          >
            {t('ui.action.cancelOrder')}
          </Button>
        }
        open={isModalOpen}
      >
        <Header content={t('ui.confirm.cancelOrder')} />
        <Modal.Content>
          <div>
            <div className="subscription-detail-cancel-order-service-group-name">
              {`${pickServiceGroupName(subscription)}`}
            </div>
            <div className="subscription-detail-cancel-order-request-code">
              {`${t('models.subscription.requestCode')}： ${
                subscription.requestCode ? subscription.requestCode : ''
              }`}
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button data-test="cancel" onClick={handleClose}>
            {t('ui.action.cancel')}
          </Button>
          <Button
            color="red"
            data-test="execute"
            onClick={() => {
              cancelSubscription(subscription.id);
              handleClose();
            }}
          >
            {t('ui.action.executeCancelOrder')}
          </Button>
        </Modal.Actions>
      </Modal>
    </Styled>
  );
};

const Styled = styled.div`
  .subscription-detail-cancel-order-service-group-name {
    font-weight: bold;
  }

  .subscription-detail-cancel-order-request-code {
    margin-top: 0.5em;
  }
`;
